//React Components and Hooks
import {
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  Box,
  Typography as MuiTypography,
} from "@mui/material";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import SimpleStatCard from "../../components/cards/SimpleStatCard"; // The stat cards displaying simple analytic numbers
//import DropDownCard from '../../components/cards/DropDownCard';
import StandardHeader from "../../components/global/StandardHeader";
// Custom application component imports:
import { LeftSidebar as NavFrame } from "layout-blueprints"; // The top navigation bar and side navigation panel
import { getAnalyticalData } from "../../modules/apl/api/actions";
import {
  getAllBillingDashboardInfo,
  getAllCompanyBillingAnalytics,
  resetBillingObject,
} from "../../modules/billing/api/actions";
import CurrentBillBatchesManagerTable from "../../modules/billing/components/CurrentBillBatchesManagerTable";
import CurrentBillDraftsManagerTable from "../../modules/billing/components/CurrentBillDraftsManagerTable";
import { logout } from "../../modules/user/api/actions";
// Helper methods:
import { formatMoney } from "../../setup/helpers";
import AnalyticsRange_DD from "./AnalyticsRange_DD"; // Dropdown to set the scope of the analytics data

const Divider = styled(MuiDivider)(spacing);
const Typography = styled(MuiTypography)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  percentDif: {
    textAlign: "right",
    color: "green",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const BillingDashboard = (props) => {
  const classes = useStyles();
  const params = useParams();

  const [queryDelay, setQueryDelay] = useState(
    params.querydelay || null
  );
  const [isLoaded, setIsLoaded] = useState(false);
  const [delayedIsLoaded, setDelayedIsLoaded] = useState(false);

  const logout = () => {
    props.logout();
  };

  const getCompanyBillingDataAndRefreshPage = (isLoading = true) => {
    props.getAllBillingDashboardInfo(isLoading);
    props.getAllCompanyBillingAnalytics(isLoading);
  };

  // On initial page load:
  useEffect(() => {
    if (props.user.details.isSuperUser ||props.user.details.billing || props.user.details.administration) {
      if (!isLoaded) {
        getCompanyBillingDataAndRefreshPage();
        setIsLoaded(true);
      }
      if (queryDelay != null) {
        const interval = setInterval(() => {
          if (!delayedIsLoaded) {
            getCompanyBillingDataAndRefreshPage(false);
            clearInterval(interval);
            setDelayedIsLoaded(true);
          }
        }, queryDelay);
        //return () =>
      }
    }
  }, [queryDelay]);
  var pageTitle = "Billing Dashboard";
  document.title = "Ubil+ Billing Dashboard";
  // On Data Loaded:
  return (
    <NavFrame page={"BillingDashboard"}>
      <StandardHeader
        title={pageTitle}
        rightSideToolBar={
          !!(props.user.details.billing || props.user.details.administration || props.user.details.isSuperUser)  && 
            <AnalyticsRange_DD
              handleRefreshClick={getCompanyBillingDataAndRefreshPage}
            />
          
        }
      />
      <Divider className="mb-3 mt-3" />
      {props.user.details.billing || props.user.details.administration || props.user.details.isSuperUser ? (
        <Box>
          {/* Top stats cards */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 4 }}>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(25% - 12px)' } }}>
              <SimpleStatCard
                title="Properties Billed"
                amount={
                  props.billing.data.billingWizardDashboard.propertiesBilled ||
                  "-"
                }
                chip="This Month"
                isLoaded={!props.billing.billAnalyticsIsLoading}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(25% - 12px)' } }}>
              <SimpleStatCard
                title="Total $ "
                amount={
                  formatMoney(
                    props.billing.data.billingWizardDashboard.totalCharged
                  ) || "-"
                }
                chip="This Month"
                isLoaded={!props.billing.billAnalyticsIsLoading}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(25% - 12px)' } }}>
              <SimpleStatCard
                title="Total KwH"
                amount={props.billing.data.billingWizardDashboard.kwhUsage || "0"}
                chip="This Month"
                isLoaded={!props.billing.billAnalyticsIsLoading}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(25% - 12px)' } }}>
              {/*<DropDownCard
              title="Remaining Properties to Bill this Month"
              amount={props.billing.data.billingWizardDashboard.estimatedUsage || "-"}
              chip="This Month"
              isLoaded={!props.billing.billAnalyticsIsLoading}
            />*/}
            </Box>
          </Box>
          {/* Bottom tables */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(50% - 8px)' } }}>
              <CurrentBillDraftsManagerTable />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 calc(50% - 8px)', lg: '1 1 calc(50% - 8px)' } }}>
              <CurrentBillBatchesManagerTable />
            </Box>
          </Box>
        </Box>
      ) : (
        <h3>You do not have billing privilages</h3>
      )}
    </NavFrame>
  );
};

// Component Properties
BillingDashboard.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getAllBillingDashboardInfo: PropTypes.func.isRequired,
  resetBillingObject: PropTypes.func.isRequired,
  getAllCompanyBillingAnalytics: PropTypes.func.isRequired,
};

// Component State
function BillingDashboardPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
  };
}
export default connect(BillingDashboardPageState, {
  logout,
  getAnalyticalData,
  getAllBillingDashboardInfo,
  resetBillingObject,
  getAllCompanyBillingAnalytics,
})(BillingDashboard);
